import { useTranslation } from 'react-i18next';

export const ResultNotFond = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-5 flex items-center px-5">
      {t(
        '条件に合致するデータがありませんでした、条件を変更して再度検索してください。'
      )}
    </div>
  );
};
